import { render, staticRenderFns } from "./EstadoCivilField.vue?vue&type=template&id=52135504&scoped=true&"
import script from "./EstadoCivilField.vue?vue&type=script&lang=js&"
export * from "./EstadoCivilField.vue?vue&type=script&lang=js&"
import style0 from "./EstadoCivilField.vue?vue&type=style&index=0&id=52135504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52135504",
  null
  
)

export default component.exports